@let ast = asset();

@switch (mode()) {
  @case ('thumbnail') {
    <i class="bi bi-calendar-event"></i>
  }
  @case ('view') {
    @if (dataResource.isLoading()) {
      <div class="text-muted small">Loading events…</div>
    } @else if (dataResource.error(); as err) {
      <div class="text-danger small">{{ err }}</div>
    } @else if (dataResource.hasValue()) {
      @let data = dataResource.value()!;
      <div class="person-events">
        <h6 class="mb-2">{{ data.personName }}</h6>
        <ul class="list-unstyled mb-0">
          @for (event of data.events; track event.eventId) {
            <li class="mb-2">
              <span class="fw-semibold">{{ event.eventName ?? 'Event' }} {{event.description ?? ''}} </span>
              @if (event.date) {
                <span class="text-muted ms-1">{{ event.date }}</span>
              }
              @if (event.place) {
                <span class="text-muted ms-1">· {{ event.place }}</span>
              }
              @if (event.photoAssetIds.length > 0) {
                <div class="d-flex flex-wrap gap-1 mt-1">
                  @for (photoId of event.photoAssetIds; track photoId) {
                    <img [src]="photoUrl(photoId)" class="event-photo" [alt]="event.eventName ?? ''" />
                  }
                </div>
              }
            </li>
          }
        </ul>
      </div>
    }
  }
  @case ('details') {
    <dl>
      <div class="row">
        <dt>Person:</dt>
        <dd>{{ ast.personName }}</dd>
      </div>
      <div class="row">
        <dt>Storage:</dt>
        <dd><pre class="mb-0">{{ ast.storagePath }}</pre></dd>
      </div>
    </dl>
    @if (dataResource.hasValue()) {
      <pre class="small">{{ dataResource.value() | json }}</pre>
    }
  }
}
